import { isNotEmptyObject } from "../../utilities/text.utils"
import {getDefaultServiceType} from "../../utilities/account-service-utils"

export   const capitalize = stringRaw => {
  const string = `${stringRaw}`
  const arr = string.split(" ")
  for (let i = 0; i < arr.length; i++) {
    arr[i] = arr[i][0].toUpperCase() + arr[i].substr(1).toLowerCase()
  }
  const stringTwo = arr.join('')
  return stringTwo
}

export const isBrowser = () => typeof window !== "undefined"

// user removeItem to clear session
export const vfghClearSession = () =>
  isBrowser() && window.localStorage.removeItem("selfCareUser")
    ? JSON.parse(window.localStorage.removeItem("selfCareUser"))
    : {}
// get reset password user

export const getUserReset = () =>
  isBrowser() && window.localStorage.getItem("resetUser")
    ? JSON.parse(window.localStorage.getItem("resetUser"))
    : {}

export const setUserReset = user =>
  window.localStorage.setItem("resetUser", JSON.stringify(user))

// get user
export const getUser = () =>
  isBrowser() && window.localStorage.getItem("selfCareUser")
    ? JSON.parse(window.localStorage.getItem("selfCareUser"))
    : {}

export const setUser = user => {
  window.localStorage.setItem("selfCareUser", JSON.stringify(user))
}

export const getServiceID = () =>
  isBrowser() && window.localStorage.getItem("serviceID")
    ? JSON.parse(window.localStorage.getItem("serviceID"))
    : {}
export const setServiceID = serviceID =>
  window.localStorage.setItem("serviceID", JSON.stringify(serviceID))

// set service list

export const getServiceList = () =>
  isBrowser() && window.localStorage.getItem("serviceList")
    ? JSON.parse(window.localStorage.getItem("serviceList"))
    : {}
export const setServiceList = serviceList =>
  window.localStorage.setItem("serviceList", JSON.stringify(serviceList))

// end of servicelist object

export const getLinkedNumbers = () =>
  isBrowser() && window.localStorage.getItem("linkedNumbers")
    ? JSON.parse(window.localStorage.getItem("linkedNumbers"))
    : {}

export const setLinkedNumbers = linkedNumbers =>
  window.localStorage.setItem("linkedNumbers", JSON.stringify(linkedNumbers))

  //**********getting call history data */
  export const getCallHIstoryData = () =>
  isBrowser() && window.localStorage.getItem("callHistoryData")
    ? JSON.parse(window.localStorage.getItem("callHistoryData"))
    : {}

  //*******getting password reset username */
  export const getPasswordUsername = () =>
  isBrowser() && window.localStorage.getItem("storedUsername")
    ? window.localStorage.getItem("storedUsername")
    : ""


export const getToken = () =>
  isBrowser() && window.localStorage.getItem("token")
    ? JSON.parse(window.localStorage.getItem("token"))
    : ""

export const setToken = token =>
  window.localStorage.setItem("token", JSON.stringify(token))



export const getEnterpriseUser = () =>
  isBrowser() && window.localStorage.getItem("User")
    ? JSON.parse(window.localStorage.getItem("User"))
    : {}
export const setEnterpriseUser = user =>
  window.localStorage.setItem("User", JSON.stringify(user))

// Start Get and Set lastVisitedPage
export const getLastVisitedPage = () =>
isBrowser() && window.sessionStorage.getItem("lastVisitedPage")
  ? window.sessionStorage.getItem("lastVisitedPage")
  : "";
export const setLastVisitedPage = (page) =>
window.sessionStorage.setItem("lastVisitedPage", page);

// End Get and Set lastVisitedPage

// Start Get and Set lastServiceType
export const getLastServiceType = () =>
isBrowser() && window.sessionStorage.getItem("lastServiceType")
  ? window.sessionStorage.getItem("lastServiceType")
  : "";
export const setLastServiceType = (page) =>
window.sessionStorage.setItem("lastServiceType", page);

// End Get and Set lastServiceType


// End Get and Set lastServiceType


export const getUserType = () =>{
  let userType = null
  const enterpriseUser = isNotEmptyObject(getEnterpriseUser()) 
  const individualUser = isNotEmptyObject(getUser())
  if(enterpriseUser){
    userType = "enterprise"
  }else if(individualUser){
    userType = getDefaultServiceType()
  }
  return userType
  
}

export const dashBoardPath = (userType)=>{
  let path = null
  if(userType === "enterprise"){
    path = `${process.env.play_base_url}/enterprise`
  } else {
    path = `${process.env.play_base_url}/dashboard/`
  }
  return path
}